export default __webpack_public_path__ + "static/Montserrat-Bold-bad41f06d63c8b5b9a4f139244342087.woff2";